<div class="py-md">
  <hr class="app-divider">
  <div class="pt-xs ts-body description-wrapper"
       [innerHTML]="truncatedTxt()"></div>

  <div *ngIf="isTruncated()"
       (click)="descriptionModal.present()"
       class="ts-small-bold text-azzurro-500 read-more pt-sm">
    <div>Mostra descrizione completa</div>
    <div class="material-symbols-outlined">chevron_right</div>
  </div>

</div>

<ion-modal #descriptionModal
           [initialBreakpoint]="1"
           [breakpoints]="[0, 1]"
           [canDismiss]="true">
  <ng-template>

    <ion-content fullscreen="false"
                 class="ion-padding">

      <div class="d-flex ion-justify-content-end">
        <ion-fab-button (click)="descriptionModal.dismiss()"
                        class="default">
          <span class="material-symbols-outlined">close</span>
        </ion-fab-button>
      </div>

      <div class="modal-content">
        <p class="ts-body" [innerHTML]="text()"></p>
      </div>
    </ion-content>

  </ng-template>
</ion-modal>
